import React from 'react';

import Document from 'components/Document';
import documentStyles from 'components/Document/Document.module.scss';

import styles from './PrivacyPolicy.module.scss';

const PrivacyPolicy = () => {
  return (
    <Document title="Privacy Policy">
      <p className={documentStyles.bodyText}>
        This Privacy Policy applies to the website (
        <a
          className={documentStyles.link}
          href="https://www.hfsfinancial.net"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.hfsfinancial.net
        </a>
        ), which is owned by HFS Financial, LLC (“Company,” “we,” “us,” or “our”). By accessing and using the website,
        you agree to the terms of this Privacy Policy.
      </p>
      <p className={documentStyles.title}>Server Logs</p>
      <p className={documentStyles.bodyText}>
        Our servers record your computer’s IP address and website usage in “server logs” when you use the website. No
        personally identifiable information is contained in these logs, such as name, address, phone numbers or email
        addresses. We use these logs to help diagnose problems with our servers, analyze traffic patterns and to
        administer the website.
      </p>
      <p className={documentStyles.title}>Cookies</p>
      <p className={documentStyles.bodyText}>
        We use cookies on certain pages of our website. Cookies are small text files stored on your hard drive, not on
        our website. A cookie is not a program and does not itself have the ability to automatically collect personal
        information about you. A cookie can store certain information that identifies your browser to our servers to
        make the website operate more smoothly. For example, we use cookies to aid in the functioning of a sign in form.
        Most cookies we use are “session cookies” which means that they are automatically deleted when you leave the
        website.
      </p>
      <p className={documentStyles.title}>Voluntary Contact</p>
      <p className={documentStyles.bodyText}>
        If you send us information voluntarily, such as through a form on the website or through personal correspondence
        or email, or if other users or third parties send us correspondence about your activities, we may collect such
        information. We use such information, and other information that we obtain from your use of the services we
        provide, to process your requests, resolve disputes, troubleshoot problems, and enforce our Terms of Use, among
        other things. Please also note that information you volunteer in public areas is not protected information, and
        anyone could potentially collect and use such information in ways we cannot control. In addition to using your
        information as described above, we also may occasionally send you email announcing special promotions, changes
        in our services, and other information we believe will be of interest to you. You may opt in or out of receiving
        these communications by using the join/unsubscribe feature located in any email we send. We cannot ensure that
        all your private communications and other personally identifiable information will never be disclosed in ways
        not otherwise described in this Privacy Policy. For example, we may be forced to disclose information to the
        government or third parties under certain circumstances without your consent, or third parties may unlawfully
        intercept or access transmissions or private communications. We can (and you authorize us to) disclose any
        information about you to law enforcement or other government officials as we, in our sole discretion, believe
        necessary or appropriate in connection with an investigation of fraud, intellectual property infringements, or
        other activity that is illegal or that may expose us to legal liability. However, we will not use your
        information for marketing purposes without your consent. We do not sell or rent our list of users past or
        present to any third party without your consent.
      </p>
      <p className={documentStyles.title}>With Whom do we Share Your Information</p>
      <p className={documentStyles.bodyText}>
        In submitting an inquiry for a loan product or other service offered through the website, when you click on any
        button indicating an acceptance or agreement to terms, a continuance of processing or submission, you signify
        your agreement to proceed you are consenting, acknowledging, and agreeing to the disclosure of information you
        provide to our lending partners (to match you for a loan). BE AWARE that a lending partner with whom you are
        matched may retain or use your information whether you use their services as described in each lending partner’s
        separate privacy policy.
      </p>
      <p className={documentStyles.title}>Linked Websites</p>
      <p className={documentStyles.bodyText}>
        For your convenience, the website contains links to other sites. Please be aware that we are not responsible for
        the privacy practices or content of such other websites, which may differ significantly from our own. We
        encourage our users to be aware when they leave our website and to read the privacy policy of each website that
        collects personally identifiable information. This Privacy Policy applies solely to information collected by our
        website.
      </p>
      <p className={documentStyles.title}>Security</p>
      <p className={documentStyles.bodyText}>
        The website has commercially reasonable procedural security measures in place designed to protect the loss,
        misuse, and alteration of the information you provide. As noted above, we do not guarantee that third parties
        will not unlawfully intercept or access transmissions or private communications that include information you
        provide.
      </p>
      <p className={documentStyles.title}>A Special Note About Children</p>
      <p className={documentStyles.bodyText}>
        The website is directed only to individuals in the locations we serve who are at least 18 years of age. The
        website is not directed to minors and children under the age of 13 are directed not to submit personal
        information to us.
      </p>
      <p className={documentStyles.title}>Changes</p>
      <p className={documentStyles.bodyText}>
        We may make changes to this Privacy Policy at any time by posting an updated version on our website.
      </p>
      <p className={documentStyles.title}>Contacting Us</p>
      <p className={documentStyles.bodyText}>
        If you have any questions about this Privacy Policy, the practices of the website, or your dealings with the
        website, you may email us at{' '}
        <a className={styles.link} href="mailto:info@hfsfinancial.net" target="_blank" rel="noopener noreferrer">
          info@hfsfinancial.net
        </a>
      </p>
      <p className={documentStyles.largeCenterTitle}>
        The following only applies to California Residents if and to the extent that Company is subject to the
        California Consumer Privacy Act:
      </p>
      <p className={documentStyles.title}>NOTICE TO CALIFORNIA RESIDENTS – CCPA</p>
      <p className={documentStyles.bodyText}>
        The California Consumer Privacy Act (“CCPA”) provides California residents with certain rights concerning how
        personal information is collected, used, managed, and stored.
      </p>
      <p className={documentStyles.title}>Personal information that we collect, use, and share </p>
      <p className={documentStyles.bodyText}>
        We do not sell personal information. As we explain in this Privacy Policy, we use server logs and cookies to,
        among other things, analyze website traffic, diagnose problems, and facilitate advertising.
      </p>
      <p className={documentStyles.title}>Your California privacy rights</p>
      <p className={documentStyles.bodyText}>
        The CCPA grants California residents the following rights. However, these rights are not absolute, and in
        certain cases we may decline your request as permitted by law.
      </p>
      <ul className={styles.list}>
        <li className={styles.listItem}>
          <span className={styles.boldText}>Information. </span>
          You can request information about how we have collected, used, and shared and used your personal information
          during the past 12 months.
        </li>
        <li className={styles.listItem}>
          <span className={styles.boldText}>Deletion. </span>
          You can ask us to delete the personal information that we have collected from you.
        </li>
        <li className={styles.listItem}>
          <span className={styles.boldText}>Information. </span>
          You can request information about how we have collected, used, and shared and used your personal information
          during the past 12 months.
        </li>
      </ul>
      <p className={documentStyles.bodyText}>
        You are entitled to exercise the rights described above free from discrimination in the form of legally
        prohibited increases in the price or decreases in the quality of our services.
      </p>
      <p className={documentStyles.title}>How to exercise your California rights</p>
      <p className={documentStyles.bodyText}>
        You may exercise your California privacy rights described above as follows:
      </p>
      <ul className={styles.list}>
        <li className={styles.listItem}>
          <span className={styles.boldText}>Information. </span>
          You can request information about how we have collected, used, and shared and used your personal information
          during the past 12 months.
        </li>
        <li className={styles.listItem}>
          <span className={styles.boldText}>Right to information, access, and deletion. </span>
          You can request to exercise your information, access, and deletion rights, by emailing us at{' '}
          <a className={styles.link} href="mailto:info@hfsfinancial.net" target="_blank" rel="noopener noreferrer">
            info@hfsfinancial.net
          </a>
          . We reserve the right to confirm your California residence to process your requests and will need to confirm
          your identity to process your requests to exercise your information, access, or deletion rights. As part of
          this process, government identification may be required. Consistent with California law, you may designate an
          authorized agent to make a request on your behalf. To designate an authorized agent to make a request on your
          behalf, you must provide a valid power of attorney, the requester’s valid government-issued identification,
          and the authorized agent’s valid government issued identification. We cannot process your request if you do
          not provide us with sufficient detail to allow us to understand and respond to it.
        </li>
        <li className={styles.listItem}>
          <span className={styles.boldText}>Request a list of third-party marketers. </span>
          California’s “Shine the Light” law (California Civil Code § 1798.83) allows California residents to ask
          companies with whom they have formed a business relationship primarily for personal, family or household
          purposes to provide certain information about the companies’ sharing of certain personal information with
          third parties for their direct marketing purposes during the preceding year (if any). You can submit such a
          request by sending an email to us at{' '}
          <a className={styles.link} href="mailto:info@hfsfinancial.net" target="_blank" rel="noopener noreferrer">
            info@hfsfinancial.net
          </a>{' '}
          with “Shine the Light” in the subject line. The request must include your current name, street address, city,
          state, and zip code and attest to the fact that you are a California resident.
        </li>
      </ul>
      <p className={documentStyles.bodyText}>
        We cannot process your request if you do not provide us with sufficient detail to allow us to understand and
        respond to it.
      </p>
      <p className={documentStyles.title}>Sharing your personal information</p>
      <p className={documentStyles.bodyText}>
        We do not sell, trade, or rent users’ personal identification information to others in accordance with the CCPA.
        We may share generic aggregated demographic information not linked to any personal identification information
        regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes
        outlined above.
      </p>
      <p className={documentStyles.bodyText}> Last Revised: January 2023</p>
    </Document>
  );
};

export default PrivacyPolicy;
